import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export const UI = {
  es: {
    services: "Servicios",
    gallery: "Galería",
    testimonials: "Testimonios",
    contact: "Contacto",
    call: "Llamar ahora",
    whatsapp: "WhatsApp directo",
    freeQuote: "Cotización gratis",
    ourServices: "Nuestros servicios",
    servicesSub: "Limpieza profesional para cada tipo de espacio comercial y residencial.",
    recentWork: "Trabajos recientes",
    gallerySub: "Resultados reales de nuestro equipo en Rhode Island.",
    clientsSay: "Lo que dicen nuestros clientes",
    contactTitle: "Hablemos de su espacio",
    contactSub: "Respuesta rápida, cotización sin compromiso. Personal confiable, atención personalizada y resultados que se notan.",
    cities: "Ciudades que servimos",
    hours: "Horario",
    location: "Ubicación",
    admin: "Admin",
    rights: "Todos los derechos reservados.",
    viewSite: "Ver sitio",
    whatsappMsg: "Hola D'Best Cleaning Services, me gustaría solicitar una cotización.",
    formTitle: "Solicita tu cotización gratis",
    formName: "Nombre",
    formPhone: "Teléfono",
    formEmail: "Email",
    formService: "Tipo de servicio",
    formOther: "Otro",
    formMessage: "Cuéntanos sobre tu espacio...",
    formSend: "Enviar solicitud",
    formSending: "Enviando...",
    formSuccess: "¡Solicitud enviada! Te contactaremos muy pronto.",
    formError: "No se pudo enviar. Intenta por WhatsApp.",
  },
  en: {
    services: "Services",
    gallery: "Gallery",
    testimonials: "Testimonials",
    contact: "Contact",
    call: "Call now",
    whatsapp: "Direct WhatsApp",
    freeQuote: "Free quote",
    ourServices: "Our services",
    servicesSub: "Professional cleaning for every kind of commercial and residential space.",
    recentWork: "Recent work",
    gallerySub: "Real results from our team across Rhode Island.",
    clientsSay: "What our clients say",
    contactTitle: "Let's talk about your space",
    contactSub: "Fast response, no-obligation quote. Trusted staff, personalized attention, and results you can see.",
    cities: "Cities we serve",
    hours: "Hours",
    location: "Location",
    admin: "Admin",
    rights: "All rights reserved.",
    viewSite: "View site",
    whatsappMsg: "Hello D'Best Cleaning Services, I would like to request a quote.",
    formTitle: "Request your free quote",
    formName: "Name",
    formPhone: "Phone",
    formEmail: "Email",
    formService: "Service type",
    formOther: "Other",
    formMessage: "Tell us about your space...",
    formSend: "Send request",
    formSending: "Sending...",
    formSuccess: "Request sent! We'll contact you very soon.",
    formError: "Could not send. Please try WhatsApp.",
  },
};

export function SiteProvider({ children }) {
  const [content, setContent] = useState(null);
  const [lang, setLangState] = useState(() => localStorage.getItem("dbest_lang") || "es");

  const setLang = (l) => {
    localStorage.setItem("dbest_lang", l);
    setLangState(l);
  };

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch((e) => console.error(e));
  }, []);

  const t = (field) => {
    if (field && typeof field === "object") return field[lang] ?? field.es ?? "";
    return field || "";
  };

  return (
    <Ctx.Provider value={{ content, setContent, lang, setLang, t, ui: UI[lang] }}>
      {children}
    </Ctx.Provider>
  );
}

export const useSite = () => useContext(Ctx);
